var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page page-with-bg"},[_c('div',{staticClass:"page-form-wrap"},[_c('div',{staticClass:"page-form-header"},[_c('h1',[_vm._v("Video Content")]),_c('div',{staticClass:"description"},[_c('h2',[_c('i',[_vm._v("Coming Soon!")])])])])])])
}]

export { render, staticRenderFns }